export default __webpack_public_path__ + "static/media/PeriodicTables.43b3591d.png";